export function getImageUrlValue(image) {
  if (!image) return ''
  if (typeof image === 'string') return image.trim()
  return (image.url || image.imageUrl || '').trim()
}

export function isExternalImageUrl(image) {
  const value = getImageUrlValue(image)
  if (!value) return false
  if (typeof image !== 'string' && (image.source === 'upload' || image.publicId)) return false
  return /^https?:\/\//i.test(value)
}

export function parseImageUrl(value) {
  const originalValue = typeof value === 'string' ? value.trim() : ''
  if (!originalValue) return { valid: false, message: 'Enter a valid http(s) image URL.' }

  try {
    const url = new URL(originalValue)
    if (!['http:', 'https:'].includes(url.protocol)) throw new Error('Unsupported protocol')
    return { valid: true, url: originalValue, source: 'url', type: 'image' }
  } catch {
    return { valid: false, message: 'Enter a valid http(s) image URL.' }
  }
}